import {
  CHECK_KYC_SEEN,
  SET_BLOCKED,
  SET_MFA,
  SET_USER,
  SET_USER_DATA,
  SHOW_MESSAGE,
  SIGN_OUT,
  SET_FEEDBACK_SURVEY_STATE
} from "./actionTypes";
import {
  bankSeenStatus,
  checkEmail,
  deleteBankByTag,
  getFeedbackFormStatus,
  getPayee,
  kycSeenStatus,
  logEvent,
  ping,
  refreshTokens,
  signUp,
  thirdPartyLogin,
  updateMfaStatus,
} from "../api";
import { isFunction } from "formik";
import { Magic, DeepLinkPage } from "magic-sdk";
import config from "../../utils/config";
import { clearLocalStorage, initalizeUserForLoggers } from "../../utils";
import { ACTIVITY_META, ACTIVITY_DETAIL, EVENTS } from "../../utils/events";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import { getPockytConnectedBanks } from "./TransferActions";

/**
 *
 * @param {email: string, didToken: string} data
 * @param { callback } onSuccess
 * @param { callback } onFailure
 * @returns void
 */


export const login =
  (data, onSuccess, onFailure, method = null) =>
    async (dispatch) => {
      try {
        if (!method) {
          // check if email exists or not
          await checkEmail({
            email: data.email.trim(),
            tcLink: config.TERMS_CONDITION,
            privacyLink: config.PRIVACY_POLICY
          });
          logEvent({
            current: EVENTS.LOGIN_EVENT,
            activity: 'Clicked on login button',
            meta: {
              data
            }
          })
          const magic = new Magic(config.PK_MAGIC_LINK);
          const didToken = await magic.auth.loginWithEmailOTP(data);
          const payload = {
            data,
            headers: {
              "x-did-token": `Bearer ${didToken}`,
            },
          };

          const userMetaData = await magic.user.getMetadata();
          const response = await signUp(payload);
          await dispatch({
            type: SET_USER,
            payload: {
              ...response.result
            },
          });
          await dispatch({
            type: SET_MFA,
            payload: userMetaData?.isMfaEnabled,
          });
          logEvent({
            current: EVENTS.LOGIN_EVENT,
            activity: 'login success',
            meta: {
              data
            }
          })

          //update current status of MFA
          await updateMfaStatus({
            status: userMetaData?.isMfaEnabled,
          });
        } else {
          const payload = {
            method,
            access_token: data.access_token,
          };

          const response = await thirdPartyLogin(payload);
          if (response?.result?.mfaEnabled) {
            dispatch(login({ email: response?.result?.email }, onSuccess, onFailure));
            return;
          } else {
            await dispatch({
              type: SET_USER,
              payload: response.result,
            });
          }
        }
        if (isFunction(onSuccess)) onSuccess();
      } catch (err) {
        logEvent({
          current: EVENTS.LOGIN_EVENT,
          activity: 'login failed',
          meta: {
            data,
            error: err?.response?.data || err
          }
        })
        if (isFunction(onFailure)) onFailure(err);
      }
    };

export const refreshToken = () => async (dispatch) => {
  try {
    const response = await refreshTokens();
    await dispatch({
      type: SET_USER,
      payload: response.result,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const getPayeeData = (onSuccess) => async (dispatch) => {
  try {
    const response = await getPayee();
    initalizeUserForLoggers(response.result);
    await dispatch({
      type: SET_USER_DATA,
      payload: response.result,
    });
    if (isFunction(onSuccess)) onSuccess(response.result);
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const signout = () => async (dispatch) => {
  try {
    const magic = new Magic(config.PK_MAGIC_LINK);
    magic.user.logout();
    clearLocalStorage();
    dispatch({
      type: SIGN_OUT,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const setBlockedStatus = (value) => (dispatch) => {
  dispatch({
    type: SET_BLOCKED,
    payload: value,
  });
};

export const checkKycSeenStatus = (update) => async (dispatch) => {
  try {
    const response = await kycSeenStatus(update);
    dispatch({
      type: CHECK_KYC_SEEN,
      payload: !response.result.status,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};


export const getVersion = () => async (dispatch) => {
  try {
    await ping();
  } catch (err) {
    // dispatch({
    //   type: SHOW_MESSAGE,
    //   payload: {
    //     type: MESSAGE_BAR_TYPES.ERROR,
    //     message: err?.response?.data?.message || err.message
    //   }
    // });
  }
}

export const enableMFA = (email, meta = {}, onComplete) => async (dispatch) => {
  try {
    const magic = new Magic(config.PK_MAGIC_LINK);
    await magic.auth.loginWithEmailOTP({
      email: email
    });
    await magic.user.showSettings({ page: DeepLinkPage.MFA });
    const userMetaData = await magic.user.getMetadata();
    await dispatch({
      type: SET_MFA,
      payload: userMetaData?.isMfaEnabled,
    });

    await updateMfaStatus({
      status: userMetaData?.isMfaEnabled,
    });

    if (userMetaData?.isMfaEnabled) {
      logEvent({
        current: EVENTS['2FA']['2FA_COMPLETED'],
        activity: ACTIVITY_DETAIL['2FA']['2FA_COMPLETED'],
        meta: {
          data: {
            pathname: meta?.location?.pathname,
            source: meta?.isPopup ? ACTIVITY_META['2FA']['FROM_POPUP'] : ACTIVITY_META['2FA']['FROM_MENU']
          }
        }
      });
    }
    onComplete();
  } catch (err) {
    onComplete();
    console.log(err);
  }
}
export const showFeedbackSurvey = () => async (dispatch) => {
  try {
    const response = await getFeedbackFormStatus();

    await dispatch({
      type: SET_FEEDBACK_SURVEY_STATE,
      payload: response.result.showFeedback,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};
export const updateFeedbackSurveyState = (status) => async (dispatch) => {
  await dispatch({
    type: SET_FEEDBACK_SURVEY_STATE,
    payload: status
  })
}


export const checkBankSeenStatus = (payload) => async (dispatch) => {
  try {
    await bankSeenStatus(payload);
    dispatch(getPockytConnectedBanks());

  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};


export const deleteBank = (payload) => async (dispatch) => {
  try {
    await deleteBankByTag(payload);
    dispatch(getPockytConnectedBanks());

  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};
